import { TranslationInfo } from '../translation-map';
import translationEntries from './ce.json';

export const czechTranslationInfo: TranslationInfo = {
  languageName: 'Czech',
  languageCode: 'ce',
  direction: 'ltr',
  translations: translationEntries,
};
